export default __webpack_public_path__ + "static/media/single-layer.8f7e9738.svg";